import _ from 'lodash';
import React, { Component } from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './Input.css';

const dumbInput = dumbBem('landing-form-input');
const InputWrp = tx(dumbInput)('div');

const InputElWrp = tx([{ element: 'el-wrp' }, dumbInput])('div');
const InputEl = tx([{ element: 'el' }, dumbInput])('input');
const ErrorMsg = tx([{ element: 'error-msg' }, dumbInput])('div');


export class Input extends Component {
  render() {
    return (
      <InputWrp>
        <InputElWrp>
          <InputEl
            {..._.omit(this.props, 'errorMsg')}
            modifier={this.props.errorMsg ? 'error' : ''}
          />
        </InputElWrp>
        {this.props.errorMsg && <ErrorMsg>{this.props.errorMsg}</ErrorMsg>}
      </InputWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/components/input/Input.js